import { Box, Dialog, DialogContent, DialogTitle, Grid, Typography } from "@material-ui/core"
import { MyDialog } from "../../components/Dialog"
import ButtonWithLoading from "../../components/ButtonWithLoading"
import ExpandCircleLoading from "../../components/expandCircle"

export const MakeAlertDialog=({open,onClose,onClick})=>{
    return (
      <MyDialog
        open={open}
        title="Alert"
        onClose={onClose}
        headerStyle={{ backgroundColor: "#004467" }}
      >
        <DialogContent>
          <Grid container spacing={3}>
            <Grid item>
              <ButtonWithLoading
                color="primary"
                title="Contrôle ONEM-PERSONNEL"
                variant="contained"
                textColor="white"
                onClick={()=>onClick("Contrôle ONEM-PERSONNEL")}
              />
            </Grid>
            <Grid item>
              <ButtonWithLoading
                color="primary"
                title="Contrôle ONSS-LOIS SOCIALES"
                variant="contained"
                textColor="white"
                onClick={()=>onClick("Contrôle ONSS-LOIS SOCIALES")}
              />
            </Grid>
            <Grid item>
              <ButtonWithLoading
                color="primary"
                title="Contrôle GROUPÉ (PERSONNEL-AFSCA-FISCALITÉ-POLICE)"
                variant="contained"
                textColor="white"
                onClick={()=>onClick("Contrôle GROUPÉ (PERSONNEL-AFSCA-FISCALITÉ-POLICE)")}
              />
            </Grid>
            <Grid item>
              <ButtonWithLoading
                color="primary"
                title="Contrôle AFSCA"
                variant="contained"
                textColor="white"
                onClick={()=>onClick("Contrôle AFSCA")}
              />
            </Grid>
            <Grid item>
              <ButtonWithLoading
                color="primary"
                title="Contrôle TVA-FISCALITÉ-ACCISES"
                variant="contained"
                textColor="white"
                onClick={()=>onClick("Contrôle TVA-FISCALITÉ-ACCISES")}
              />
            </Grid>
            <Grid item>
              <ButtonWithLoading
                color="primary"
                title="Contrôle SECURITE - INCENDIE"
                variant="contained"
                textColor="white"
                onClick={()=>onClick("Contrôle SECURITE - INCENDIE")}
              />
            </Grid>
            <Grid item>
              <ButtonWithLoading
                color="primary"
                title="Contrôle ENVIRONNEMENTAL"
                variant="contained"
                textColor="white"
                onClick={()=>onClick("Contrôle ENVIRONNEMENTAL")}
              />
            </Grid>
            <Grid item>
              <ButtonWithLoading
                color="primary"
                title="Contrôle LICENCES - AUTORISATIONS"
                variant="contained"
                textColor="white"
                onClick={()=>onClick("Contrôle LICENCES - AUTORISATIONS")}
              />
            </Grid>
            <Grid item>
              <ButtonWithLoading
                color="primary"
                title="Contrôle SABAM-UNISONO - DROITS D'AUTEURS"
                variant="contained"
                textColor="white"
                onClick={()=>onClick("Contrôle SABAM-UNISONO - DROITS D'AUTEURS")}
              />
            </Grid>
          </Grid>
          <br />
          <br />
          {/* <ExpandCircleLoading/><Typography> Search in the area..</Typography> */}

          {/* <Box display="flex" justifyContent="center">
            <ButtonWithLoading
              color="primary"
              title="Ok"
              variant="contained"
              textColor="white"
            />
          </Box> */}
        </DialogContent>
      </MyDialog>
    );
}